import { useEffect } from 'react';
import { LinkTracker } from './LinkTracker';
import { useInvite } from '../hooks/useInvite';

export const Invite = (props) => {
    console.log(props)
    const guestName = props.authorizedGuest ? props.authorizedGuest.guestName : null;
    const {
        accessId, 
        handleUpdatePings,
        getLinkProps,
        createRecord,
    } = useInvite(guestName);

    useEffect(handleUpdatePings);

    useEffect(createRecord, [createRecord, accessId, guestName]);

    return (
        <div className={'App'}>
            <div className={'video-and-invite-container'}>
                <div 
                    className={'circle video-container'}
                >
                    <iframe 
                        width={'100%'}
                        height={'100%'}
                        src={'https://www.youtube.com/embed/wPLSd2Ux-84?si=hEG-4-KLPhEUUm9S'} 
                        title={'YouTube video player' }
                        frameborder={0}
                        allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'} 
                        referrerpolicy={'strict-origin-when-cross-origin'}
                        allowfullscreen
                    >
                    </iframe>
                </div>
                <div className={'links-container'}>
                    <LinkTracker {...getLinkProps('hotel')}/>
                    {' • '}
                    <LinkTracker {...getLinkProps('visa')}/>
                    {' • '}
                    <LinkTracker {...getLinkProps('passport')}/>
                </div>
            </div>
        </div>
    );
};